import React from "react";
import { useState, useEffect } from "react";

import {
  Modal,
  Input,
  Button,
  Form,
  Checkbox,
  message,
  Select,
  Alert,
  Table,
  notification,
  Spin,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";

import {
  GetEntriesForEvent,
  GetSchools,
  UpdateSubstitutions,
  GetRowers,
  VerifyCoxWeightStatus,
  LockCoxWeight,
  GetCoxWeightStatus,
  GetSchedules,
} from "../../APIManager";

import { ListOfEvents } from "../../constants";

import { ListOfDays } from "../../constants";

import styles from "./CoxWeight.module.css";
import { useForm } from "antd/lib/form/Form";

const { confirm } = Modal;
const { Option } = Select;

export default function CoxWeight({}) {
  const [entries, SetEntries] = useState([]);
  const [rowers, SetRowers] = useState([]);
  const [schools, SetSchools] = useState([]);
  const [schedules, SetSchedules] = useState([]);
  const [selectedCox, SetSelectedCox] = useState("");
  const [selectedDay, SetSelectedDate] = useState("31st Jan");
  const [selectedEventName, SetSelectedEventName] = useState("");
  const [selectedSchool, SetSelectedSchool] = useState("");

  const [awaitingResponse, SetAwaitingResponse] = useState(true);

  const [errorMessage, SetErrorMessage] = useState("");
  const [warningMessage, SetWarningMessage] = useState("");
  const [showWeightLock, SetShowWeightLock] = useState(false);
  const [showDetailsModal, SetShowDetailsModal] = useState(false);

  const [coxWeightStatus, SetCoxWeightStatus] = useState([]);

  const [weight, SetWeight] = useState(0);
  const [signedBy, SetSignedBy] = useState("");
  const [lockingWeight, SetLockingWeight] = useState(false);
  const [searchText, SetSearchText] = useState("");

  useEffect(() => {
    SetWarningMessage("");
    SetErrorMessage("");
    SetWeight(0);
  }, [selectedCox]);

  useEffect(() => {
    GetSchools().then((Res) => {
      SetSchools(Res.data);
    });
    GetRowers().then((res) => {
      SetRowers(res.data);
    });

    GetSchedules().then((res) => {
      SetSchedules(res.data);
    });
  }, []);

  useEffect(() => {
    GetCoxWeightStatus(selectedDay).then((res) => {
      SetCoxWeightStatus(res.data);
      console.log(res.data);
    });
  }, [selectedDay]);

  function GetSchool(id) {
    return schools.filter((s) => s._id == id)[0];
  }

  function RefreshEntries() {
    GetEntriesForEvent(selectedCox).then((Res) => {
      SetEntries(Res.data);
      SetAwaitingResponse(false);
    });
  }

  const schoolCoxes = schools.map((s) => s.coxes).flat();
  const coxes = rowers
    .filter((r) => schoolCoxes.includes(r._id))
    .sort((a, b) => a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()));

  const columns = [
    {
      title: "Cox",
      dataIndex: "Name",
      key: "Name",
    },
    {
      title: "Races Scheduled Today",
      dataIndex: "RacesScheduledToday",
      key: "RacesScheduledToday",
      render: (text, record) => {
        if (text === false) {
          return CheckRenderer(text);
        }
        return CheckRenderer(text);
      },
      filters: filters,
      onFilter: (value, record) => record.IsWeighed === value,
    },
    {
      title: "Details",
      key: "actions",
      render: (_, record) => (
        <Button
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            if (!record.RacesScheduledToday) {
              notification.error({
                message: `${record.Name} has no races scheduled for today today`,
                description: "",
                placement: "topRight",
                duration: 5,
                maxCount: 1,
              });
              return;
            }

            SetShowDetailsModal(true);
            SetSelectedCox(record._id);
          }}
        >
          View Details
        </Button>
      ),
    },
  ];

  const detailsColumns = [
    {
      title: "Event Name",
      dataIndex: "EventName",
      key: "EventName",
    },
    {
      title: "Weighed",
      dataIndex: "IsWeighed",
      key: "IsWeighed",
      render: (text, record) => {
        if (text === false) {
          return CheckRenderer(text);
        }
        return CheckRenderer(text);
      },
      filters: filters,
      onFilter: (value, record) => record.IsWeighed === value,
    },
    {
      title: "Hours to Race",
      dataIndex: "HoursToRace",
      key: "HoursToRace",
      render: (text, record) => {
        return `${Math.floor(text)}h ${Math.round((text % 1) * 60)}m`;
      },
    },
    {
      title: "Weight Details",
      dataIndex: "WeightDetails",
      key: "WeightDetails",
      render: (text, record) => {
        const weight = record.WeightDetail?.Weight;
        const sandbag = record.WeightDetail?.Sandbags;
        const signedBy = record.WeightDetail?.SignedBy;

        if (weight) {
          const dateLocked = new Date(record.WeightDetail?.DateLocked);

          return (
            <div>
              <div>
                <strong>Weight: </strong>
                {weight} KG{" "}
              </div>
              <div>
                <strong>Sandbags: </strong>
                {sandbag} KG{" "}
              </div>
              <div>
                <strong>Locked By: </strong>
                {signedBy}
              </div>
              <div>
                <strong>Time: </strong>
                {dateLocked.toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })}
              </div>
            </div>
          );
        } else return "-";
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          size="small"
          disabled={record.IsWeighed}
          onClick={(e) => {
            e.stopPropagation();

            const selectedCoxName = coxes.find(
              (c) => c._id == selectedCox,
            )?.Name;

            if (record.HoursToRace < 1) {
              notification.warning({
                message: `${selectedCoxName} has their first event within 1 hour`,
                description: "",
                placement: "topRight",
                duration: 5,
                maxCount: 1,
              });
              SetSelectedEventName(record.EventName);
              SetShowDetailsModal(false);
              SetShowWeightLock(true);
              SetWarningMessage(
                `${selectedCoxName} has their first event within 1 hour`,
              );
            } else if (record.HoursToRace > 2.1) {
              notification.error({
                message: `${selectedCoxName}'s First Race is after ${
                  Math.round(record.HoursToRace * 10) / 10
                } hours `,
                description:
                  "Rowers may only be weighed within 2 hours of their first race",
                placement: "topRight",
                duration: 5,
                maxCount: 1,
              });
              SetShowWeightLock(false);
            } else {
              SetWarningMessage("");
              SetShowWeightLock(true);
              SetSelectedEventName(record.EventName);
              SetShowDetailsModal(false);
            }
          }}
        >
          Add Weight
        </Button>
      ),
    },
  ];

  const rowProps = {
    onClick: (record) => {
      SetSelectedCox(record._id);
      console.log(record);
    },
  };

  return (
    <div>
      <div>
        <h1>Select Day</h1>
        <Select
          value={selectedDay}
          placeholder="Select a Day"
          style={{ width: "50ch" }}
          onChange={(e) => {
            SetSelectedDate(e);
          }}
        >
          {schedules.map(function (item, i) {
            return <Option value={item.Day}>{item.Day}</Option>;
          })}
        </Select>
      </div>
      <br />
      <div>
        <Input
          placeholder="Search by rower name..."
          value={searchText}
          onChange={(e) => SetSearchText(e.target.value)}
          style={{ width: "50ch", marginBottom: "16px" }}
          allowClear
        />
      </div>
      <div>
        <Table
          dataSource={coxWeightStatus.filter((cox) =>
            cox.Name?.toLowerCase().includes(searchText.toLowerCase()),
          )}
          columns={columns}
          pagination={false}
          style={{ fontSize: "2em" }}
          className={styles.Table}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                /*           VerifyCoxWeightStatus({
                  coxID: record._id,
                  day: selectedDay,
                }).then((res) => {
                  if (res.data.Error) {
                    notification.error({
                      message: res.data.Message,
                      description: res.data.Message,
                      placement: "topRight",
                      duration: 5,
                      maxCount: 1,
                    });
                    SetErrorMessage(res.data.Message);
                    SetWarningMessage("");
                    SetShowWeightLock(false);
                  } else {
                    SetErrorMessage("");

                    var hours = res.data.Hours;
                    console.log(hours);
                    if (hours < 1) {
                      notification.warning({
                        message: `${record.Name} has their first even within 1 hour`,
                        description: "",
                        placement: "topRight",
                        duration: 5,
                        maxCount: 1,
                      });
                      SetShowWeightLock(true);
                      SetWarningMessage(
                        `${record.Name} has their first even within 1 hour`
                      );
                    } else if (hours > 16.5) {
                      notification.error({
                        message: `${record.Name}'s First Race is after ${
                          Math.round(hours * 10) / 10
                        } hours `,
                        description:
                          "Rowers may only be weighed within 2 hours of their first race",
                        placement: "topRight",
                        duration: 5,
                        maxCount: 1,
                      });
                      SetShowWeightLock(false);
                    } else {
                      SetWarningMessage("");
                      SetShowWeightLock(true);
                    }
                  }
                }); */
              }, // click row
            };
          }}
        />
      </div>
      <br />
      <div hidden>
        <h1>Select a Cox</h1>
        <Select
          showSearch
          value={selectedCox}
          placeholder="Select a Cox"
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          allowClear
          style={{ width: "50ch" }}
          onChange={(e) => {
            SetSelectedCox(e);
          }}
        >
          {coxes.map(function (item, i) {
            return (
              <Option value={item._id}>
                {`${item.Name} (${GetSchool(item.Team._id)?.schoolinitials})`}
              </Option>
            );
          })}
        </Select>
      </div>
      <br />
      {selectedCox && (
        <Modal
          title={`Viewing ${coxes.filter((c) => c._id == selectedCox)[0]?.Name} Races for ${selectedDay}`}
          forceRender
          visible={showDetailsModal}
          onOk={() => {}}
          onCancel={() => {
            SetShowDetailsModal(false);
          }}
          width="1200px"
          okButtonProps={{
            hidden: true,
          }}
          cancelButtonProps={{ hidden: true }}
          maskClosable={false}
        >
          <Table
            dataSource={
              coxWeightStatus.filter((c) => c._id == selectedCox)[0]
                .WeightsByEventsToday
            }
            columns={detailsColumns}
            pagination={false}
            style={{ fontSize: "2em" }}
          />
        </Modal>
      )}

      <Modal
        title={`Lock COX Weight for ${
          coxes.filter((c) => c._id == selectedCox)[0]?.Name
        } for ${selectedEventName} on ${selectedDay}`}
        forceRender
        visible={showWeightLock}
        onOk={() => {}}
        onCancel={() => {
          SetShowWeightLock(false);
        }}
        okText="Delete"
        cancelText="cancel"
        width="1200px"
        okButtonProps={{
          hidden: true,
        }}
        cancelButtonProps={{ hidden: true }}
        maskClosable={false}
      >
        {" "}
        {showWeightLock && (
          <>
            <div hidden={errorMessage.length < 1}>
              <Alert
                message="Error"
                //description={`You have not assigned ${no} students to any race However, They will stil be incuded in the total registration fees. It is best if you either assign them to a race or delete them from the Team Registration Page`}
                description={<div>{errorMessage}</div>}
                type="error"
                showIcon
              />
            </div>
            <div hidden={warningMessage.length < 1}>
              <Alert
                message="Warning"
                //description={`You have not assigned ${no} students to any race However, They will stil be incuded in the total registration fees. It is best if you either assign them to a race or delete them from the Team Registration Page`}
                description={<div>{warningMessage}</div>}
                type="warning"
                showIcon
              />
            </div>
            <br />
            <br />
            <Input
              addonBefore="Weight in KG"
              type="number"
              value={weight}
              onChange={(e) => {
                if (e.target.value) {
                  SetWeight(Math.round(e.target.value * 2) / 2);
                } else {
                  SetWeight(0);
                }
              }}
            />
            <br />
            <br />
            <label
              style={{ fontSize: "1.4em", fontWeight: "bold" }}
              hidden={weight < 35}
            >
              Sandbags:{" "}
              {weight > 50
                ? "No Sandbags Required"
                : `${50 - weight}KG Required`}
            </label>
            <label
              style={{ fontSize: "1.4em", fontWeight: "bold", color: "Red" }}
              hidden={weight >= 35}
            >
              Underweight
            </label>
            <br />
            <br />
            <Input
              addonBefore="Sign your Name"
              type="text"
              value={signedBy}
              onChange={(e) => {
                SetSignedBy(e.target.value);
              }}
            />
            <br />
            <br />

            <Button
              type="primary"
              disabled={
                errorMessage.length > 1 ||
                weight < 25 ||
                !signedBy ||
                lockingWeight
              }
              loading={lockingWeight}
              onClick={() => {
                SetLockingWeight(true);
                LockCoxWeight({
                  coxID: selectedCox,
                  day: selectedDay,
                  weight: weight,
                  eventName: selectedEventName,
                  sandbag: weight > 50 ? 0 : 50 - weight,
                  signedBy: signedBy,
                })
                  .then(() => {
                    // Refetch cox weight status data
                    GetCoxWeightStatus(selectedDay).then((res) => {
                      SetCoxWeightStatus(res.data);
                      SetLockingWeight(false);
                      SetShowWeightLock(false);
                      SetShowDetailsModal(true);
                      SetWeight(0);
                      SetSignedBy("");
                      SetSelectedEventName("");
                      notification.success({
                        message: "Weight locked successfully",
                        placement: "topRight",
                        duration: 3,
                      });
                    });
                  })
                  .catch((err) => {
                    SetLockingWeight(false);
                    notification.error({
                      message: "Failed to lock weight",
                      description: err.message || "An error occurred",
                      placement: "topRight",
                      duration: 5,
                    });
                  });
              }}
            >
              Lock Weight
            </Button>
          </>
        )}
      </Modal>
    </div>
  );
}

function CheckRepeatSubs(subs) {
  var oSubs = [...subs].map((s) => s.sID);

  return oSubs.length !== new Set(oSubs).size;
}

function CheckRenderer(text) {
  if (text === true) {
    return <CheckCircleTwoTone twoToneColor="#52c41a" />;
  } else {
    return <CloseCircleTwoTone twoToneColor="#eb2f96" />;
  }
}

const filters = [
  {
    text: "Completed",
    value: true,
  },
  {
    text: "Incomplete",
    value: false,
  },
];
